import { ScheduleTaskAttributeResourceCalculationKeyBase } from './base/schedule-task-attribute-resource-calculation-key-base';

export class ScheduleTaskAttributeResourceCalculationKey extends ScheduleTaskAttributeResourceCalculationKeyBase { }